export enum EnumAttendeeState {
  'new' = 'new',
  'active' = 'active',
  'closed' = 'closed',
}
